var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPilot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 116,
    viewBox: "0 0 129 116",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 84.8951H16.007C11.8956 84.8951 8.10047 86.5818 5.35955 89.3227C2.61862 92.0637 0.931885 95.8588 0.931885 99.9702C0.931885 108.298 7.67877 115.045 16.007 115.045H112.361C116.472 115.045 120.268 113.359 123.008 110.618C125.749 107.877 127.436 104.082 127.436 99.9702C127.436 91.642 120.689 84.8951 112.361 84.8951ZM112.361 107.455H16.007C11.8956 107.455 8.62755 104.082 8.62755 99.9702C8.62755 95.8588 12.001 92.5907 16.007 92.5907H112.361C116.472 92.5907 119.741 95.9642 119.741 99.9702C119.846 104.082 116.472 107.455 112.361 107.455Z",
    fill: "url(#paint0_linear_6619_1828)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.786 8.67587H13.5821C6.62439 8.67587 0.931702 8.3596 0.931702 7.93792V1.82356C0.931702 1.40188 6.62439 1.0856 13.5821 1.0856H114.786C121.743 1.0856 127.436 1.40188 127.436 1.82356V7.93792C127.436 8.3596 121.743 8.67587 114.786 8.67587Z",
    fill: "#4796FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5937 0.980286H3.56734C2.19688 0.980286 1.03723 2.1399 1.03723 3.51037V6.04048C1.03723 7.41094 2.19688 8.57056 3.56734 8.57056H56.5937V0.980286Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0057 84.8952H42.8878C43.2041 84.4735 43.3095 83.9464 43.3095 83.4193V60.5431C43.3095 59.1726 42.1499 58.013 40.7794 58.013H17.9032C16.5328 58.013 15.3732 59.1726 15.3732 60.5431V83.4193C15.3732 83.9464 15.584 84.4735 15.9003 84.8952C15.9003 84.8952 15.9002 84.8952 16.0057 84.8952Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.662 69.398H95.4936C94.7557 69.398 94.2286 68.8708 94.2286 68.1329V57.9072H103.927V68.1329C103.927 68.8708 103.295 69.398 102.662 69.398Z",
    fill: "#8DBEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.61 0.980286H71.881V8.57056H124.907C126.278 8.57056 127.437 7.41094 127.437 6.04048V3.51037C127.437 2.1399 126.278 0.980286 124.907 0.980286H110.57",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0587 74.8801V83.5245C85.0587 84.0516 85.2696 84.5787 85.4804 85.0004H112.363C112.468 85.0004 112.468 85.0004 112.573 85.0004C112.89 84.5787 113.101 84.0516 113.101 83.5245V60.6483C113.101 59.2779 111.941 58.1182 110.57 58.1182H87.6942C86.3238 58.1182 85.1642 59.2779 85.1642 60.6483V66.0247",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8751 69.3981H25.7066C24.9686 69.3981 24.4415 68.8709 24.4415 68.133V57.9073H34.1402V68.133C34.1402 68.8709 33.6131 69.3981 32.8751 69.3981Z",
    fill: "#8DBEFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.662 69.398H95.4936C94.7557 69.398 94.2286 68.8708 94.2286 68.1329V57.9072H103.927V68.1329C103.927 68.8708 103.295 69.398 102.662 69.398Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8751 69.3981H25.7066C24.9686 69.3981 24.4415 68.8709 24.4415 68.133V57.9073H34.1402V68.133C34.1402 68.8709 33.6131 69.3981 32.8751 69.3981Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.361 115.045H16.007C7.67877 115.045 0.931885 108.298 0.931885 99.9702C0.931885 91.642 7.67877 84.8951 16.007 84.8951H112.361C120.689 84.8951 127.436 91.642 127.436 99.9702C127.436 108.298 120.689 115.045 112.361 115.045Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0062 107.455C20.14 107.455 23.4911 104.104 23.4911 99.97C23.4911 95.8362 20.14 92.4852 16.0062 92.4852C11.8725 92.4852 8.52142 95.8362 8.52142 99.97C8.52142 104.104 11.8725 107.455 16.0062 107.455Z",
    fill: "#4796FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.36 107.455C116.494 107.455 119.845 104.104 119.845 99.97C119.845 95.8362 116.494 92.4852 112.36 92.4852C108.226 92.4852 104.875 95.8362 104.875 99.97C104.875 104.104 108.226 107.455 112.36 107.455Z",
    fill: "#4796FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3715 107.455C52.5052 107.455 55.8563 104.104 55.8563 99.97C55.8563 95.8362 52.5052 92.4852 48.3715 92.4852C44.2377 92.4852 40.8867 95.8362 40.8867 99.97C40.8867 104.104 44.2377 107.455 48.3715 107.455Z",
    fill: "#4796FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1037 107.455C84.2375 107.455 87.5886 104.104 87.5886 99.97C87.5886 95.8362 84.2375 92.4852 80.1037 92.4852C75.9699 92.4852 72.6189 95.8362 72.6189 99.97C72.6189 104.104 75.9699 107.455 80.1037 107.455Z",
    fill: "#4796FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0062 107.455C20.14 107.455 23.4911 104.104 23.4911 99.97C23.4911 95.8362 20.14 92.4852 16.0062 92.4852C11.8725 92.4852 8.52142 95.8362 8.52142 99.97C8.52142 104.104 11.8725 107.455 16.0062 107.455Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M112.36 107.455C116.494 107.455 119.845 104.104 119.845 99.97C119.845 95.8362 116.494 92.4852 112.36 92.4852C108.226 92.4852 104.875 95.8362 104.875 99.97C104.875 104.104 108.226 107.455 112.36 107.455Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3715 107.455C52.5052 107.455 55.8563 104.104 55.8563 99.97C55.8563 95.8362 52.5052 92.4852 48.3715 92.4852C44.2377 92.4852 40.8867 95.8362 40.8867 99.97C40.8867 104.104 44.2377 107.455 48.3715 107.455Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1037 107.455C84.2375 107.455 87.5886 104.104 87.5886 99.97C87.5886 95.8362 84.2375 92.4852 80.1037 92.4852C75.9699 92.4852 72.6189 95.8362 72.6189 99.97C72.6189 104.104 75.9699 107.455 80.1037 107.455Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3404 92.5904H16.0062C11.8948 92.5904 8.52142 95.9638 8.52142 100.075C8.52142 104.187 11.8948 107.56 16.0062 107.56H112.36C116.472 107.56 119.845 104.187 119.845 100.075C119.845 95.9638 116.472 92.5904 112.36 92.5904H37.1957",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8798 0.980286H56.5939V24.3836H71.8798V0.980286Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51.008 37.1397L48.1616 33.2391C47.8453 32.8175 47.8453 32.1849 48.1616 31.7632L55.2248 21.9592C55.4356 21.6429 55.8573 21.4321 56.279 21.4321H56.5952V14.7906H53.9597C52.9055 14.7906 51.8513 15.3177 51.3242 16.161L41.2039 30.2874C40.2551 31.6578 40.2551 33.45 41.2039 34.715L51.1134 48.5251L51.008 37.1397Z",
    stroke: "#8DBEFF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2724 30.2874L77.152 16.161C76.5195 15.3177 75.5707 14.7906 74.5165 14.7906H71.881V21.4321H72.1972C72.6189 21.4321 73.0406 21.6429 73.2514 21.9592L80.3146 31.7632C80.6309 32.1849 80.6309 32.8175 80.3146 33.2391L77.4682 37.1397V48.5251L87.3778 34.715C88.2211 33.3446 88.2212 31.6578 87.2724 30.2874Z",
    stroke: "#8DBEFF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6148 24.4891H57.8589C57.121 24.4891 56.5939 23.9619 56.5939 23.224V1.08575H71.8798V23.224C71.8798 23.8565 71.2473 24.4891 70.6148 24.4891Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7255 60.9647H53.536C52.0601 60.9647 50.9005 59.805 50.9005 58.3292V37.1397C50.9005 35.6638 52.0601 34.5042 53.536 34.5042H74.7255C76.2013 34.5042 77.361 35.6638 77.361 37.1397V58.3292C77.361 59.6996 76.2013 60.9647 74.7255 60.9647Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6619_1828",
    x1: 7.473,
    y1: 86.8152,
    x2: 120.452,
    y2: 113.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DBEFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilot);
export default __webpack_public_path__ + "static/media/pilot.a728c493276f7ca1eb04dc4973b32cbe.svg";
export { ForwardRef as ReactComponent };